import React, { useState, useRef, useEffect, ReactNode } from 'react';

interface LazyLoadProps {
  children: ReactNode;
  height?: number | string;
  className?: string;
  threshold?: number; // 触发加载的距离阈值
  placeholder?: ReactNode;
}

const LazyLoad: React.FC<LazyLoadProps> = ({
  children,
  height = 'auto',
  className = '',
  threshold = 100,
  placeholder = null,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasLoaded) {
          setIsVisible(true);
          setHasLoaded(true);
          // 一旦加载就不再观察
          observer.disconnect();
        }
      },
      {
        rootMargin: `${threshold}px`,
        threshold: 0.1,
      },
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [threshold, hasLoaded]);

  return (
    <div ref={elementRef} className={className} style={{ minHeight: height }}>
      {isVisible ? children : placeholder}
    </div>
  );
};

export default LazyLoad;
